import { useEvent } from '@bizzabo/entities';

import { MeetingsProvider } from './MeetingsToolContext';
import MeetingsToolView from './MeetingsToolView';
import useTypeTracking from '../../../analytics';

interface MeetingsToolPropTypes {
    eventUniqueName: string;
}

const MeetingsTool: React.FC<MeetingsToolPropTypes> = ({ eventUniqueName }) => {
    const { isLoading, isIdle } = useEvent(eventUniqueName);

    const { Track } = useTypeTracking({
        data: {
            category: 'MEETING_AREA',
        },
    });

    if (isIdle || isLoading) {
        return null;
    }

    return (
        <Track>
            <MeetingsProvider eventUniqueName={eventUniqueName}>
                <MeetingsToolView />
            </MeetingsProvider>
        </Track>
    );
};

export default MeetingsTool;
